import PropTypes from 'prop-types';

import './index.less';

function Statistic({ title, Icon, value, success, danger }) {
  return (
    <>
      <span className="statistic__title">{title}</span>
      <div className={`statistic__amount ${success ? 'success' : ''} ${danger ? 'danger' : ''}`}>
        <Icon />
        <span>{value}</span>
      </div>
    </>
  );
}

Statistic.propTypes = {
  title: PropTypes.string.isRequired,
  Icon: PropTypes.elementType.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  success: PropTypes.bool,
  danger: PropTypes.bool,
};

Statistic.defaultProps = {
  value: 0,
  success: false,
  danger: false,
};

export default Statistic;
